var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_10_2397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93241 2.93244C4.22879 1.63608 6.02114 0.833374 8.00001 0.833374C9.97888 0.833374 11.7712 1.63608 13.0676 2.93244C14.364 4.22882 15.1667 6.02117 15.1667 8.00004C15.1667 9.97891 14.364 11.7713 13.0676 13.0676C11.7712 14.364 9.97888 15.1667 8.00001 15.1667C6.02114 15.1667 4.22879 14.364 2.93241 13.0676C1.63605 11.7713 0.833344 9.97891 0.833344 8.00004C0.833344 6.02117 1.63606 4.22882 2.93241 2.93244ZM8.00001 1.83337C6.29701 1.83337 4.75603 2.52305 3.63951 3.63955C2.52302 4.75606 1.83334 6.29704 1.83334 8.00004C1.83334 9.70304 2.52302 11.244 3.63952 12.3605C4.75603 13.477 6.29701 14.1667 8.00001 14.1667C9.70301 14.1667 11.244 13.477 12.3605 12.3605C13.477 11.244 14.1667 9.70304 14.1667 8.00004C14.1667 6.29704 13.477 4.75606 12.3605 3.63955C11.244 2.52305 9.70301 1.83337 8.00001 1.83337Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 12.3334C8.46024 12.3334 8.83334 11.9603 8.83334 11.5C8.83334 11.0398 8.46024 10.6667 8.00001 10.6667C7.53978 10.6667 7.16668 11.0398 7.16668 11.5C7.16668 11.9603 7.53978 12.3334 8.00001 12.3334Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 3.50004C8.27615 3.50004 8.50001 3.7239 8.50001 4.00004V9.33337C8.50001 9.60952 8.27615 9.83337 8.00001 9.83337C7.72387 9.83337 7.50001 9.60952 7.50001 9.33337V4.00004C7.50001 3.7239 7.72387 3.50004 8.00001 3.50004Z",
    fill: "#2D2943"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_2397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.f3ebd2bb.svg";
export { ForwardRef as ReactComponent };